import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BulkTransactionComponent } from './bulk-transaction.component';
import { BatchDetailComponent } from './batch-detail/batch-detail.component';

const routes: Routes = [
  {
    path: '',
    component: BulkTransactionComponent,
  },
  {
    path: 'detail/:id',
    component: BatchDetailComponent,
    data: { breadcrumb: 'Batch Detail' },
  },
  {
    path: 'new-batch',
    loadChildren: () =>
      import('./new-batch/new-batch.routing.module').then(m => m.NewBatchRoutingModule),
    data: { breadcrumb: 'New Batch' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BulkTransactionRoutingModule {}
